import { Assets } from '@shared/config/market/market.models';

export const semboAssets: Assets = {
    checkMark: 'https://images.sembo.se/SE/symbols/checkmark.png',
    starIcon: 'https://images.sembo.se/SE/symbols/star-icon.svg',
    halfStarIcon: 'https://images.sembo.se/SE/symbols/half-star-icon.svg',
    favIcon:
        'https://cdn.sanity.io/files/inntox6v/production/eb2ade293a3815af6b2d77b20fce75c912fb1e0b.ico',
    addButton: 'https://images.sembo.se/SE/symbols/add-button.svg',
};

export const stenaAssets: Assets = {
    checkMark: 'https://images.sembo.se/SE/symbols/stena/checkmark.png',
    starIcon: 'https://images.sembo.se/SE/symbols/stena/star-icon.png',
    halfStarIcon: 'https://images.sembo.se/SE/symbols/stena/half-star-icon.png',
    favIcon:
        'https://cdn.sanity.io/files/inntox6v/production/a057d46c3ddda3753fbaf22e54539a1bc6571703.ico',
    addButton: 'https://images.sembo.se/SE/symbols/stena/add-button.svg',
};
